export function getExt(path: string) {
    var lastDotIndex = path.lastIndexOf('.');
    if (lastDotIndex >= 0) {
        return path.substr(lastDotIndex);
    }
    return "";
}

function collapseDotDot(dirs: string[]): string[] {
    let right = dirs.length - 1;
    let result: string[] = [];
    while (right >= 0) {
        const cur = dirs[right];
        if (cur === '..') {
            if (right > 0) {
                if (dirs[right - 1] !== '..') {
                    right--;
                }
            }
        } else {
            result.push(cur);
        }
        right--;
    }
    return result;
}

/**
 * resolve relative paths against base bath
 * @param paths paths[0] as base path, the rest are relative paths
 */
export function resolve(...paths: string[]): string {
    // first replace  '/./' with '/'
    let parts = _.map(paths, path => path.replace('/./', '/'));
    // flatten out all parts into segements
    let dirs = _.flatten(_.map(parts, path => path.split('/')), true/*shallow*/);
    // reduce '..' with its non '..' left neighbor
    let right = dirs.length - 1;
    let result: string[] = collapseDotDot(dirs);

    if (result.length < dirs.length) {
        // repeat until the only '..' are at the left end of dirs
        for (; ;) {
            let prev = result;
            result = collapseDotDot(prev);
            if (result.length === prev.length) {
                break;
            }
        }
    }
    return result.join('/');
}


// WEBPACK FOOTER //
// ./../Intercom.ReactUI/Utils/Path.ts